import { useState } from "react";
import { useEffect } from "react";
import { getOrderDetails } from "../pages/api";
export const OrderInfo = ({ orders }) => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);

  const handleDetailsClick = (order) => {
    setSelectedOrder(order);
    fetchOrders(order.id);
  };

  const handleBackClick = async () => {
    console.log("Back button clicked");
    await setSelectedOrder(null);
    await console.log(selectedOrder);
    await setOrderDetails(null);
    await setPaymentDetails(null);
  };

  // useEffect(() => {
  // console.log("QUI");
  const fetchOrders = async (id) => {
    try {
      console.log(selectedOrder);
      const response = await getOrderDetails(id);
      console.log(response);
      setOrderDetails(response.orderDetails);
      setPaymentDetails(response.paymentDetails);
      const firstLetter = response.paymentMethod.brand.charAt(0);

      const firstLetterCap = firstLetter.toUpperCase();

      const remainingLetters = response.paymentMethod.brand.slice(1);

      const capitalizedWord = firstLetterCap + remainingLetters;
      response.paymentMethod.brand = capitalizedWord;
      setPaymentMethod(response.paymentMethod);
      console.log(response.paymentMethod.brand);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  };
  // fetchOrders();
  //}, []);

  return (
    <div>
      {selectedOrder && orderDetails && paymentMethod ? (
        <div className="text-left">
          {/*<button
            onClick={handleBackClick}
            className="text-white bg-red-50s0 rounded transition duration-300"
          >
            <svg
              width="24"
              height="24"
              xmlns="http://www.w3.org/2000/svg"
              fillRule="evenodd"
              clipRule="evenodd"
              className="hover:fill-blue-500 transition-all duration-300"
            >
              <path d="M20 .755l-14.374 11.245 14.374 11.219-.619.781-15.381-12 15.391-12 .609.755z" />
            </svg>
          </button> */}

          <button
            onClick={handleBackClick}
            className="text-white bg-blue-500 p-2 rounded transition duration-300 inline-block"
          >
            Indietro
          </button>

          <h2 className="text-2xl text-left font-bold my-5">
            ID Ordine: {selectedOrder.codice_ordine || selectedOrder.id}
          </h2>
          <p className="text-left text-gray-500">
            <span className="font-semibold">Stato spedizione:</span>{" "}
            <span
              className={
                selectedOrder.completato ? "text-green-500" : "text-red-500"
              }
            >
              {selectedOrder.completato ? "Spedito" : "Non Spedito"}
            </span>
          </p>
          <p className="text-left">
            <span className="text-gray-500">Data:</span>{" "}
            {new Date(selectedOrder.created_at).toLocaleDateString()}
          </p>
          <hr className="mt-5" />
          <table className="w-full bg-resd-500 max-w-6xl mt-5 text-left border-collapse ...">
            {orderDetails && (
              <tbody>
                {orderDetails.map((rivista, index) => (
                  <tr key={rivista.id}>
                    <td className="p-2 border-slate-300 flex flex-row items-center">
                      <img
                        src={rivista.stripeProduct.images[0]}
                        alt={rivista.id}
                        className="w-20 sm:w-20 h-auto"
                      ></img>
                      <div className="ml-2 sm:ml-10 flex flex-col justify-center items-start">
                        <p className="text-sm sm:text text-gray-600">
                          {rivista.stripeProduct.name}
                        </p>
                      </div>
                    </td>
                    <td colSpan={3} className="bg-gresen-500"></td>
                    <td className="bg-rsed-400 text-right text-sm sm:text-xl p-2 sm:p-2 border-slate-300">
                      €{rivista.prezzo}
                      <p className="mt-2 text-xs text-right text-gray-400">
                        Qtà:{rivista.quantita}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
          <hr className="mt-5"></hr>
          <div className="bg-resd-500 text-left mt-5 grid grid-cols-2 gap-10">
            <p className="text-left font-semibold bg-rsed-500">
              Pagamento
              {paymentMethod.type === "paypal" ? (
                <>
                  <p>PayPal</p>
                  <p>Email: {paymentMethod.paypal.payer_email}</p>
                </>
              ) : (
                <>
                  <span className="block mt-2 font-normal">
                    {paymentMethod.brand +
                      " **" +
                      paymentMethod.last4}
                  </span>
                </>
              )}
            </p>
            <p className="text-left font-semibold bg-gresen-500">
              Consegna
              <span className="block mt-2 text-sm font-normal text-gray-400 ">
                Indirizzo
              </span>
              {paymentDetails.shipping ? (
                <>
                  <span className="block mt-1 text-sm font-normal ">
                    {paymentDetails.shipping.address.line1}
                  </span>
                  <span className="block text-sm font-normal ">
                    {`${paymentDetails.shipping.address.city}, 
        ${paymentDetails.shipping.address.state}, 
        ${paymentDetails.shipping.address.country}`}
                  </span>
                  <span className="block text-sm font-normal">
                    {paymentDetails.phone ? (
                      <span>{paymentDetails.phone}</span>
                    ) : null}
                  </span>
                </>
              ) : (
                <>
                  <span className="block mt-1 text-sm font-normal ">
                    {paymentDetails.address.line1}
                  </span>
                  <span className="block text-sm font-normal ">
                    {`${paymentDetails.address.city}, 
        ${paymentDetails.address.state}, 
        ${paymentDetails.address.country}`}
                  </span>
                  <span className="block text-sm font-normal">
                    {paymentDetails.phone ? (
                      <span>{paymentDetails.phone}</span>
                    ) : null}
                  </span>
                </>
              )}
            </p>
          </div>
        </div>
      ) : (
        <div className="bg-white">
          <h2 className="text-2xl text-left font-bold mb-6">Ordini</h2>
          {orders.length > 0 ? (
            <table className="w-full mt-14 text-left border-collapse">
              <thead>
                <tr>
                  <th className="text-left e pl-10  border-b border-slate-300 pb-2 sm:pb-5 ">
                    Ordine
                  </th>
                  <th className="text-center border-b border-slate-300 pb-2 sm:pb-5">
                    Totale
                  </th>
                  <th className="text-center border-b border-slate-300 pb-2 sm:pb-5">
                    Data
                  </th>
                  <th className="text-center border-b border-slate-300 pb-2 sm:pb-5">
                    {" "}
                  </th>
                </tr>
              </thead>

              <tbody>
                {orders.map((item) => {
                  const date = new Date(item.created_at).toLocaleString();
                  return (
                    <tr
                      key={item.id}
                      className="w-full mb-4 text-left bg-reds-500 border-2 border-gray-200 rounded-lg p-4"
                    >
                      <td className="border-b p-2 sm:p-10 border-slate-300 items-center text-cet">
                        {item.codice_ordine || item.id}
                      </td>
                      <td className="border-b p-2 sm:p-10 border-slate-300 items-center">
                        <p className="bg-greesn-500">{item.totale}</p>
                      </td>
                      <td className="border-b p-2 sm:p-10 border-slate-300 bg-red-s500 items-center text-center ">
                        <p className="bg-gresen-500">{date}</p>
                      </td>
                      <td className="border-b p-2 sm:p-4 border-slate-300 bg-gresen-500">
                        <button
                          onClick={() => {
                            handleDetailsClick(item);
                            fetchOrders(item.id);
                          }}
                          className="text-center text-blue-500 bg-sgreen-500"
                        >
                          Dettagli
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p>Nessun ordine effettuato</p>
          )}
          <ul className="list-none"></ul>
        </div>
      )}
    </div>
  );
};
